import { UserType } from "@/models/enums";
import accountService from "@/services/account.service";
import { useUserStore } from "@/store/user";
import { ref } from "vue";

const activeComponent = ref<string>();
const setComponent = (component: string) => {
	activeComponent.value = component;
}

const useAccountPages = () => {
	const userStore = useUserStore();

	const isLoggedIn = (): Promise<boolean> => {
		if (userStore.getUserType === UserType.Agent) {
			return isAgentLoggedIn();
		} else {
			return isCustomerLoggedIn();
		}
	}

	const isCustomerLoggedIn = (): Promise<boolean> => {
		return new Promise((resolve, reject) => {
			accountService.isCustomerLoggedIn().then((resp) => {
				if (!resp) {
					userStore.$reset();
				}
				resolve(resp);
			}).catch((err) => {
				userStore.$reset();
				reject(err)
			})
		})
	}

	const isAgentLoggedIn = (): Promise<boolean> => {
		return new Promise((resolve, reject) => {
			accountService.isAgentLoggedIn().then((resp) => {
				if (!resp) {
					userStore.$reset();
				}
				resolve(resp);
			}).catch((err) => {
				userStore.$reset();
				reject(err)
			})
		})
	}


	return { setComponent, activeComponent, isLoggedIn }
}

export default useAccountPages;